export enum SessionTypes {
    Fvc = "ST_FVC",
    Svc = "ST_SVC",
    Diary = "ST_DIARY",
    Challenge = "ST_CHALLENGE",
    Trend = "ST_TREND",
    PreChallenge = "ST_PRECHALLENGE",
    Diluent = "ST_DILUENT",
    Dosing = "ST_DOSING",
    Recovery = "ST_RECOVERY",
    Exercise = "ST_EXERCISE",
    Baseline = "ST_BASELINE",
    Feno = "ST_FENO",
    Pcf = "ST_PCF",
    Ifr = "ST_IFR",
    Weight = "ST_WEIGHT",
    BloodPressure = "ST_BP",
    Ecg = "ST_ECG",
    EDiary = "ST_EDIARY",
    SixMinuteWalkTest = "ST_6MWT",
    Sp02 = "ST_SPO2",
    Dlco = "ST_DLCO",
    LungVolumeHelium = "ST_LV_HE",
    LungVolumePleth = "ST_LV_PLETH",
    Pef = "ST_PEF",
    Mip = "ST_MIP",
    Mep = "ST_MEP",
    Snip = "ST_SNIP",
    Cough = "ST_COUGH",
    BloodGlucose = "ST_BLOOD_GLUCOSE",
    Oscillometry = "ST_OSCILLOMETRY",
    PulseOximetry = "ST_SPO2"
}
